import SupportPage from "~/components/marketing/support/SupportPage";

export default function Pricing() {
  return <SupportPage />;
}
